<div class="custom-right-tooltip" [ngStyle]="{'right':rightPosition}">
  <span class="custom-right-tooltip-label">{{tooltipText}}</span><i class="arrow left"></i>
</div>
